import { Fragment } from 'react';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { EditIcon } from './CustomSvgIcons';
import { cardClasses } from './constants';

export default function DetailInfoCard(props) {
    const {
        cardTitleMarginBottom='0px',
        currDarkThemeClass='',
        editLink=() => console.log('Make an edit'),
        entries=[],
        entryMarginValue='16px',
        otherCardPaperSxProps={},
        otherEntriesBoxSxProps={},
        title='Unknown',
        NoEntityMessage='',
        toShowEditBtn=true,
    } = props;
    
    const dICardPaperProps = {
        className: `${cardClasses?.detailInfo?.paper} ${currDarkThemeClass}`,
        square: true,
        sx: {
            ...otherCardPaperSxProps,
        },
        variant: 'none',
    };

    const dICardTitlePaperProps = {
        className: `${cardClasses?.detailInfo?.titlePaper} ${currDarkThemeClass}`,
        square: true,
        sx: {
            mb: cardTitleMarginBottom,
        },
        variant: 'none',
    };

    const dICardTitleTypoProps = {
        className: `${cardClasses?.detailInfo?.titleTypo} ${currDarkThemeClass}`,
    };

    const dIEditIconProps = {
        className: `${cardClasses?.detailInfo?.editIcon} ${currDarkThemeClass}`,
    };

    const dICardEditBtnProps = {
        className: `${cardClasses?.detailInfo?.editButton} ${currDarkThemeClass}`,
        disableRipple: true,
        onClick: editLink,
        startIcon: <EditIcon {...dIEditIconProps} />,
    };

    const dICardEntryTypoProps = {
        className: `${cardClasses?.detailInfo?.entryTypo} ${currDarkThemeClass}`,
        sx: {
            mt: entryMarginValue,
        },
    };

    const dIEntriesBoxProps = {
        className: `${cardClasses?.detailInfo?.entriesBox} ${currDarkThemeClass} customScroll`,
        sx: {
            ...otherEntriesBoxSxProps,
        },
    };

    const entriesList = entries.map((e, i) => 
        <Fragment key={i}>
            { e.key && <Typography {...dICardEntryTypoProps}>{e.key}</Typography> }
            { e.value }
        </Fragment>
    )

    return (
        <Paper {...dICardPaperProps}>
            <Paper {...dICardTitlePaperProps}>
                <Typography {...dICardTitleTypoProps}>{title}</Typography>
                {
                    toShowEditBtn && <Button {...dICardEditBtnProps}>Edit</Button>
                }
            </Paper>
            <Box {...dIEntriesBoxProps}>
                {entriesList}
            </Box>
        </Paper>
    );
}